export const API = 'api/';
export const API_V1 = 'v1';
export const API_V2 = 'v2';

export enum ApiEndpoints {
  ADMINS = '/Admins',
  AVAILABILITIES = '/Availabilities',
  CLIENTS = '/Clients',
  CONTRACTS = '/Contracts',
  EMAIL = '/Email',
  EMAIL_CONTACT = '/EmailContact',
  EUPAGO = '/Eupago',
  FIREBASE = '/Firebase',
  FLOWS = '/Flows',
  GOOGLE_REVIEW = '/GoogleReview',
  CHATBOTS = '/Chatbot',
  CHATBOT_TEST = '/ChatbotTest',
  SCHEDULES = '/Schedules',
  SERVICES = '/Services',
  TECHNICIANS = '/Technicians',
  VERSIONS = '/Versions',
  USERS = '/Users'
}

export enum ApiEntities {
  CLIENTS = '/Clients/',
  CLIENT = '/Client/',
  TECHNICIANS = '/Technicians/',
  TECHNICIAN = '/Technician/',
  VERSIONS = '/Versions/',
  ROLLBACK = '/Rollback',
  PUBLISH = '/Publish',
  IN_TESTING = '/InTesting',
  TRANSACTIONS = '/GetTransactions/',
  MULTIBANCO = '/Multibanco',
  MBWAY = '/MbWay',
  SUPPORT_REQUEST = '/SupportRequest',
  CONTRACT_PENDING = '/ContractPending',
  CONTRACT_PAIDED = '/ContractPaided',
  CONTRACT_PAIDED_GENERATE_INVOICE = '/ContractPaidedGenerateInvoice',
  CONTRACT_EXPIRED = '/ContractExpired',
  CONTRACT_CANCELLED = '/ContractCancelled',
  SCHEDULING_PENDING = '/SchedulingPending',
  TECHNICIAN_SCHEDULING_PENDING = '/TechnicianSchedulingPending',
  SCHEDULING_CONFIRMED = '/SchedulingConfirmed',
  TECHNICIAN_SCHEDULING_CONFIRMED = '/TechnicianSchedulingConfirmed',
  SCHEDULING_FINISHED = '/SchedulingFinished',
  SCHEDULING_CANCELLED = '/SchedulingCancelled',
  TECHNICIAN_SCHEDULING_CANCELLED = '/TechnicianSchedulingCancelled',
  CONTACT_REQUEST = '/ContactRequest',
  BY_DATE = 'ByDate',
  STATUS = 'Status',
}
